import * as React from "react";
import { FormattedMessage } from "react-intl";

/* eslint-disable import/no-webpack-loader-syntax */
import ProductLogoIcon from "-!svg-react-loader!../../images/icn-logo.svg";
/* eslint-enable import/no-webpack-loader-syntax */

export const ProductTitle: React.StatelessComponent<{}> = () => (
  <React.Fragment>
    <div className="row product-title">
      <div className="col-sm-12">
        <ProductLogoIcon className="icon-big-logo" />
      </div>
      <div className="col-xs-12 col-sm-12">
        <h1>
          <ProductLogoIcon className="icon-small-logo" />
          Paragon Disk Wiper Business
        </h1>
      </div>
      <div className="col-xs-12">
        <p>
          <FormattedMessage
            id="product.title.welcome"
            defaultMessage={`Login with your My Paragon account to view all your Wipe Reports.`}
          />
        </p>
      </div>
    </div>
  </React.Fragment>
);



// WEBPACK FOOTER //
// ./src/scenes/login-page/product-title.tsx